import { observer } from 'mobx-react-lite'
import styles from './AppSearchMktuFilterPanel.module.scss'
import { mktuClassListStore } from '@/store/MktuClassList.store'
import { AppSearchMktuButton } from '@/modules/OnlineSearch/components/AppSearchMktuButton'
import { onlineSearchStore } from '@/store/OnlineSearch.store'
import cn from 'classnames'
import React, { FunctionComponent } from 'react'
import { MktuClass } from '@/services/Api/generated'

type AppSearchMktuFilterPanel = {}
export const AppSearchMktuFilterPanel: FunctionComponent<AppSearchMktuFilterPanel> =
  observer(() => {
    const selectMktu = (selectedClass: MktuClass) => {
      onlineSearchStore.toggleSelectedMktuClassInfo(selectedClass)
      onlineSearchStore.toggleSelectedMktuClassNumber(selectedClass)
    }

    const selectMktuClassShowInfo = (selectedClass: MktuClass) => {
      onlineSearchStore.setMktuClassShowInfo(
        onlineSearchStore.mktuClassShowInfo?.classNumber ===
          selectedClass.classNumber
          ? null
          : selectedClass
      )
    }
    const onLeaveHoverMktuClass = () => {
      onlineSearchStore.setMktuClassShowInfo(null)
    }

    return (
      <div className={styles.container}>
        <p className={styles.selectMktuBlockTitle}>Выберите классы МКТУ</p>
        <div className={styles.selectClassesBlock}>
          <div className={styles.selectActiveClass}>
            <p
              className={cn(styles.selectActiveClassTitle, styles.noMarginTop)}
            >
              Товары
            </p>
            <div className={styles.groupList}>
              {mktuClassListStore.producClass.map((mktuClass) => (
                <AppSearchMktuButton
                  key={mktuClass.classNumber}
                  mktuClass={mktuClass}
                  isActive={
                    onlineSearchStore.selectedMktuClassesNumbers.find(
                      (classNumber) => classNumber === mktuClass.classNumber
                    ) != null
                  }
                  onSelectClass={selectMktu}
                  onHoverClass={selectMktuClassShowInfo}
                  onLeaveHoverMktuClass={onLeaveHoverMktuClass}
                />
              ))}
            </div>
            <p className={styles.selectActiveClassTitle}>Услуги</p>
            <div className={styles.groupList}>
              {mktuClassListStore.servicesClass.map((mktuClass) => (
                <AppSearchMktuButton
                  key={mktuClass.classNumber}
                  mktuClass={mktuClass}
                  isActive={
                    onlineSearchStore.selectedMktuClassesNumbers.find(
                      (el) => el === mktuClass.classNumber
                    ) != null
                  }
                  onSelectClass={selectMktu}
                  onHoverClass={selectMktuClassShowInfo}
                  onLeaveHoverMktuClass={onLeaveHoverMktuClass}
                />
              ))}
            </div>
          </div>
          <div className={styles.classInfo}>
            <div
              className={cn(styles.classInfoContent, {
                [styles.visible]: onlineSearchStore.mktuClassShowInfo != null,
              })}
            >
              <div className={styles.classInfoTop}>
                <p className={styles.classInfoClassNum}>
                  {onlineSearchStore.mktuClassShowInfo != null
                    ? `Класс ${onlineSearchStore.mktuClassShowInfo.classNumber}`
                    : ''}
                </p>
                <p className={styles.classInfoClassType}>
                  {onlineSearchStore.mktuClassShowInfo != null
                    ? `${
                        onlineSearchStore.mktuClassShowInfo.classNumber < 35
                          ? 'товары'
                          : 'услуги'
                      }`
                    : ''}
                </p>
              </div>
              <p className={styles.classInfoInfoText}>
                {onlineSearchStore.mktuClassShowInfo?.classDescription}
              </p>
            </div>
            <div
              className={cn(styles.classInfoContent, styles.empty, {
                [styles.visible]: onlineSearchStore.mktuClassShowInfo == null,
              })}
            >
              <p className={styles.classInfoDefaultText}>
                Здесь будет информация по классу
              </p>
            </div>
          </div>
        </div>
      </div>
    )
  })
